import { isSharedIdentificationFeatureEnabled } from 'constant';

/**
 * Ana madde işareti satır nesnesinin üzerinde (`isMain`) durur; böylece sürüklemede satırla birlikte taşınır,
 * sıradan bağımsızdır. Bu fonksiyon işareti verilen sıradaki satıra taşır.
 */
export const markMainMember = (members, mainIndex) =>
  members.map((member, index) => ({ ...member, isMain: index === mainIndex }));

/** Grubun ana maddesi: işaretli satır, yoksa 1. sıradaki madde. */
export const findMainMember = (members) => members.find((member) => member.isMain) ?? members[0];

/**
 * Kaydet gövdesine eklenecek ana madde alanı.
 * Bayrak kapalıyken boş döner; BE mevcut ana maddeyi korur.
 */
export const getMainMemberPayload = (members) => {
  if (!isSharedIdentificationFeatureEnabled || members.length === 0) return {};

  return { mainMemberArticleOffer: findMainMember(members)['@id'] };
};
